import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './element-ui.js'
import './utils/hm.js'

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if (to.meta.auth) {
    if (localStorage.getItem("token")) {
      const userInfo = store.getters.userInfo
      if (!userInfo.phone) {
        store.dispatch('getInfo').then(() => {
          next()
        })
      } else {
        next()
      }
    } else {
      router.push({ path: '/', query: { to: to.name } })
    }
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
